module.exports = __webpack_public_path__ + "img/c9bd5dd.jpg";